import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Home, ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LINKS = [
  { label: 'Floor Cleaning Robots', href: '/floor-cleaning-robots' },
  { label: 'Pool Cleaning Robots', href: '/pool-cleaning-robots' },
  { label: 'Window Cleaning Robots', href: '/window-cleaning-robots' },
  { label: 'Robotic Lawn Mowers', href: '/robotic-lawn-mowers' },
  { label: 'Blog & Buying Guides', href: '/blog' },
];

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page Not Found (404) | Harpalyk</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Header />
      <main className="pt-20 min-h-screen bg-gray-50 flex items-center justify-center px-6 py-16" data-testid="not-found-page">
        <div className="max-w-lg w-full text-center">
          <p className="text-7xl font-bold text-emerald-600 mb-4">404</p>
          <h1 className="text-2xl font-bold text-gray-900 mb-3">Page Not Found</h1>
          <p className="text-gray-600 mb-8">The page you're looking for doesn't exist or has been moved. Try one of these instead:</p>
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 text-left space-y-3 mb-8">
            {LINKS.map((l) => (
              <Link key={l.href} to={l.href} className="flex items-center justify-between text-gray-700 hover:text-emerald-600 font-medium transition-colors">
                {l.label} <ArrowRight className="w-4 h-4" />
              </Link>
            ))}
          </div>
          <Link to="/" data-testid="not-found-home-btn" className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-3 rounded-lg font-semibold transition-all">
            <Home className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
